addEventListener("DOMContentLoaded", (event) => {
    const mobileSearchButton = document.querySelector(".mobile-search-button");
    const mobileSearchBar = document.querySelector(".mobile-search-bar");
    const mobileSearchBarCloseButton = document.querySelector(".mobile-search-bar-close");
    const body = document.querySelector("body");
    const backdrop = document.querySelector(".backdrop");

    mobileSearchButton.addEventListener("click", () => {
        mobileSearchBar.classList.add("active");
        body.classList.add("backdrop-is-active");
    });

    mobileSearchBarCloseButton.addEventListener("click", () => {
        mobileSearchBar.classList.remove("active");
        body.classList.remove("backdrop-is-active");
    });

    backdrop.addEventListener("click", () => {
        mobileSearchBar.classList.remove("active");
        body.classList.remove("backdrop-is-active");
    });
});
